import { useSelector } from 'react-redux';

import type { RootState } from 'app/store';

export default function useSelectedPharmacyId(): string | null {
  const { selectedPharmacyId } = useSelector((state: RootState) => state.pharmacySelector);

  return selectedPharmacyId;
}
